import type Owner from '@ember/owner';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';

import type Board from 'webapp/models-custom/board';
import BoardLoop from 'webapp/models-custom/board-loop';
import type BoardShare from 'webapp/models-custom/board-share';

export interface Args {
	model: Board | BoardLoop | null;
	trackingOrigin: string;
	onContentChange: () => void;
	onClose: () => void;
}

export default class BoardsShareScheduleBaseComponent<T extends Args> extends Component<T> {
	@service('request') declare requestService: Service.Request;
	@service('model-manager/boards') declare mmBoardsService: Service.ModelManager.Boards;
	@service('model-manager/board-loops')
	declare mmBoardLoopsService: Service.ModelManager.BoardLoops;
	@service('model-manager/board-shares')
	declare mmBoardSharesService: Service.ModelManager.BoardShares;

	@tracked shareModel!: BoardShare;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		void this.mmBoardSharesService.requestBoardShares();
		this.setupShareModel();
	}

	get isBoardLoop(): boolean {
		return this.args.model instanceof BoardLoop;
	}

	get sharePropForId(): 'loopId' | 'boardId' {
		return this.isBoardLoop ? 'loopId' : 'boardId';
	}

	setupShareModel(): void {
		if (this.args.model) {
			this.setBlankShareModel();
		}
	}

	setBlankShareModel(): void {
		const prop = this.sharePropForId;

		this.shareModel = this.mmBoardSharesService.createNewModel({
			[prop]: this.args.model?.numericId,
		});
	}
}
